import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Solucoes from "../components/solucoes"
import SEO from "../components/seo"
import "../components/applify/sass/style.scss"
import "./css/index.scss"

const SolucoesPage = () => (
  <Layout>
    <SEO title="Soluções" description="possuimos soluções inovadoras para o seu negócio. Soluções voltadas para força de vendas e restaurantes." keywords={[`soluções`, `força de vendas`, `restaurantes`]} />
    <div className="main" role="main">
      <div className="ui-hero hero-lg ui-gradient-sc ui-waves hero-svg-layer-1 sp-horizontal sp-has-buttons">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center" data-vertical_center="true" data-vertical_offset="16">
              <h1 className="animate fade-in-up-big" data-show="fade-in-up-big" data-delay="100">
                Nossas Soluções
              </h1>
              <p className="text-white">Possuimos soluções inovadoras para o seu negócio.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <Solucoes />
        </div>
      </div>
    </div>

  </Layout>
)

export default SolucoesPage
